import { Box, Button, Container, Link, Slide, Stack, Text } from '@chakra-ui/react'
import React from 'react';

export const CookeiNotice = () => {

  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    const cookieNotice = localStorage.getItem('eitum-cookie-notice');
    if (!cookieNotice) {
      const timeout = setTimeout(() => {
        setIsOpen(true);
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, []);

  const acceptCookies = (value: string) => {
    localStorage.setItem('eitum-cookie-notice', value);
    setIsOpen(false);
  }

  return (
    <Slide className="no-print" style={{ zIndex: 2000 }} direction='bottom' in={isOpen}>
      <Container bg='white' px={{ base: '0', md: '6' }}>
        <Box borderTopRadius={{ base: '0', md: 'lg' }} borderColor='brand.500' borderWidth="1px" borderBottomWidth="0" bg='brand.50' boxShadow="sm">
          <Box px="4" py={{ base: '4', md: '3.5' }}>
            <Stack
              spacing="4"
              justify={{ base: 'start', md: 'space-between' }}
              direction={{ base: 'column', md: 'row' }}
            >
              <Box mb='2'>
                <Text fontWeight='bold'>Cookie Notice</Text>
                <Text>
                  We are using cookies to give you the best experience on our website.
                  Anonymous data about application usage on this site may be used to resolve technical issues and improve the performance.
                  Please check out our <Link href='https://www.eiturbanmobility.eu/cookie-policy/' target='_blank' >Cookie Policy</Link> for more information.
                </Text>
              </Box>
              <Stack
                direction={{ base: 'column', md: 'row' }}
                spacing="3"
                align={{ base: 'stretch', md: 'center' }}
              >
                <Button onClick={() => acceptCookies('accepted')}>Accept</Button>
                <Button variant="outline" onClick={() => acceptCookies('dismissed')}>Dismiss</Button>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Container>
    </Slide>
  )
}